import { ApiResult, PaginatedResponse } from '@synergy/api';
import { request, safeRequest } from '@synergy/api';

import { Customer } from '../models/customer';

export class CustomerApi {
    constructor(protected baseUrl: string) {}

    public fetchRelatedCustomers(
        params: URLSearchParams = new URLSearchParams()
    ): Promise<ApiResult<PaginatedResponse<Customer>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/accounts/related-customers`, { params }),
            response => {
                response.data.items = response.data.items.map(Customer.fromPlainObject);
                return response.data;
            }
        );
    }

    public getCustomerBonusSettlements(
        id: number,
        params: URLSearchParams = new URLSearchParams()
    ): Promise<ApiResult<PaginatedResponse<Customer>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/supplier-bonus-settlements/${id}/available-customers`, { params }),
            response => {
                response.data.items = response.data.items.map(Customer.fromPlainObject);
                return response.data;
            }
        );
    }
}
